import React, { useContext, useEffect, useRef } from "react";
import { Col, Row } from "antd";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { IDeepDiveModalConfig, IMainContext } from "@ts/common-types";
import { COLORS, mainContext } from "@ts/constants";
import WidgetCard from "./WidgetCard";
import { getDataBasedOnFrequency } from "@/ts/widget";

interface IProductTrendAnalysisWidget {
    widgetData?: IDeepDiveModalConfig;
    title?: string;
}
const ProductTrendAnalysisWidget: React.FC<IProductTrendAnalysisWidget> = ({
    title,
    widgetData,
}) => {
    const chartRef = useRef(null);
    const { selectedDataFrequency } = useContext<IMainContext>(mainContext);
    const [productTrendData, setProductTrendData] = React.useState<any>(null);

    useEffect(() => {
        const data = widgetData?.productTrendAnalysis;
        if (data) {
            const formattedData = getDataBasedOnFrequency(
                data,
                selectedDataFrequency,
            )
            setProductTrendData(formattedData);
        }
    }, [selectedDataFrequency, widgetData.productTrendAnalysis]);

    return (
        <WidgetCard className="product-trend-analysis-container my-4" bodyPaddingClass="p-0">
            <Row
                className="fs-5 fw-bold mb-3"
                justify="space-between"
                align="middle"
            >
                <Col className="ps-4 pt-4">
                <h5>
                  {title || "Product Trend analysis"}
                </h5>
                </Col>
            </Row>
            <Row
                className="product-trend-analysis-body py-2"
                justify="space-around"
            >
                {productTrendData?.titles.map(
                    (value: string, index: number) => (
                        <Col
                            className="gutter-row text-center"
                            span={12}
                            key={index + value}
                        >
                            <WidgetCard
                                className="mx-2 my-2 rounded-4 border-0"
                            >
                                <div
                                    style={{
                                        height: "300px",
                                    }}
                                >
                                    <div className="w-100 h-100">
                                        <HighchartsReact
                                            highcharts={Highcharts}
                                            options={{
                                                ...productTrendData
                                                    .chartOptions[value],
                                                credits: false,
                                                colors: COLORS,
                                            }}
                                            ref={chartRef}
                                            containerProps={{
                                                style: {
                                                    width: "100%",
                                                    height: "100%",
                                                },
                                            }}
                                        />
                                    </div>
                                </div>
                            </WidgetCard>
                        </Col>
                    )
                )}
            </Row>
        </WidgetCard>
    );
};

export default ProductTrendAnalysisWidget;